import {
  getCookie as getCookieInServer,
  setCookie as setCookieInServer,
  OptionsType,
} from 'cookies-next/server'
import { getCookie as getCookieInClient, setCookie as setCookieInClient } from 'cookies-next/client'
import isUndefined from 'lodash/isUndefined'
import { DEFAULT_MAX_AGE, SESSION_ID } from '../../constants/cookies'
import sendLog from './sendLog'

export const checkSetAndGetSessionIdInClient = (value: string) => {
  try {
    const cookie = getCookieInClient(SESSION_ID)
    if (!isUndefined(cookie)) {
      return cookie
    }
    setCookieInClient(SESSION_ID, value, {
      domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
      maxAge: DEFAULT_MAX_AGE,
      secure: true,
      sameSite: 'none',
    })
  } catch (error) {
    if (error instanceof Error) {
      sendLog(error)
    }
  }
  return value
}

export const checkSetAndGetSessionIdInServer = async (value: string, options?: OptionsType) => {
  try {
    const cookie = await getCookieInServer(SESSION_ID, options)
    if (!isUndefined(cookie)) {
      return cookie
    }
    await setCookieInServer(SESSION_ID, value, {
      ...options,
      domain: process.env.NEXT_PUBLIC_COOKIE_DOMAIN,
      maxAge: DEFAULT_MAX_AGE,
      secure: true,
      sameSite: 'none',
    })
    return value
  } catch (error) {
    if (error instanceof Error) {
      sendLog(error)
    }
    return value
  }
}
